function parse(url) {
  return new URL(url);
}

module.exports = {
  parse
};
